import React, { Component } from "react";
import { Container, Col, Row, Modal, ModalBody } from "reactstrap";
import NavTab from "../../../components/common/global_layout/navTab";
import Footer from "../../../components/common/global_layout/footer";
import { Button, Comment, Form } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Rating from "../../../components/common/rating";
import httpClient from "../../../httpClient";
import FromToDate from "../../../components/common/Cars/fromToDate";
import PriceDetails from "../../../components/common/Cars/PriceDetails";
import PagePath from "../../../components/common/pagePath";
import Gallery from "../../../components/common/gellery";
import shared from "../../../shared";
import moment from "moment";
import { announceId, authorId, textComment } from "../../../slices/commentSlice";

class CarDetails extends Component {
  constructor(props) {
    super(props);
    const AnnounceId = this.props.match.params.id_car;
    this.state = {
      AnnounceId: AnnounceId,
      detailCar: [],
      initialComments: [],
      options: [],
      creator : {},
      comment: {
        text: "",
        rating: this.props.rating || 4,
        announce: AnnounceId,
        author: this.props.currentUser._id,
      },
      hostName : process.env.REACT_APP_SERVER_URL,
      ratingModal: false,
      images: [],
      nbrImages:0
    };
  }
  componentDidMount() {
    this.getCarDetail();
  }
  async getCarDetail() {
    return httpClient.getCarDetail(this.state.AnnounceId).then(async  (res) => {
      if(res){
        console.log(res);
        this.setState({
          detailCar: res.carDetails,
          nbrImages : res.nbrImages,
          galleryId: res.carDetails.photos[0],
          options: res.carDetails.options,
          initialComments: res.carDetails.reviews,
          commentAthors : res.users
        });
        let creator = await httpClient.getUser(res.carDetails.creator[0])
        this.setState({creator : creator})
      }
    });
  }

  submitComment(e) {
    e.preventDefault();
   this.setState({
      ratingModal: true,
    });
    this.props.dispatch(textComment(this.state.comment.text))
    this.props.dispatch(announceId(this.state.comment.announce))
    this.props.dispatch(authorId(this.props.currentUser._id))
    const cmnt = this.state.comment;
    this.setState({
      comment: {
        ...this.state.comment,
        text: "",
      },
    });
  }

  onInputChange(evt) {
    this.setState({
      comment: {
        ...this.state.comment,
        text: evt.target.value,
      },
    });
  }

  toogleRatingClose() {
    this.setState({
      ratingModal: false, 
    });
    httpClient.postCommentCar(this.props.comment).then((res) => {
      if (res === false) {
        this.props.dispatch({ type: "LOGIN_FORM" });
      } else {
        this.getCarDetail();
      }
    });
  }


  getOptions() {
    return shared.getOptions(this.state.options)
  }

  render() {
    const HOST_NAME = this.state.hostName
    const creator = this.state.creator
    var detailCar = this.state.detailCar;
    const reviews = this.state.initialComments;
    var siegeBebe = "";
    var parjour = [];
    var parmois = [];
    var parsemaine = [];

    const {
      title,
      annee,
      marque,
      modele,
      commune,
      region,
      pays,
      energie,
      transmission,
      kilometrage,
      moteur,
      nbrPortes,
      nbrSiege,
      options,
      parJrs,
      parMois,
      parSemaine,
      couleur,
      rating
    } = detailCar;
    let users = this.state.commentAthors
    var opt = this.getOptions();
    const option1 = opt.firstDivOptions.map(function (option, i) {
      return <p>{option}</p>;
    });
    const option2 = opt.secondDivOptions.map(function (option, i) {
      return <p>{option}</p>;
    });

    if (options) {
      siegeBebe = options.find((option) => option === "Siége Bébé");
    }
    if (parJrs && parMois && parSemaine) {
      parjour = parJrs;
      parmois = parMois;
      parsemaine = parSemaine;
    }
    const reviewsBloc = reviews.map( (itemRv, i)=> {
      var author = users.find(e => e._id === itemRv.author[0]);
      if (typeof author  === "undefined") {
        author = {name : "Unkown"}
      }
      return (
        <Comment className="commnets-block" key={i}>
          <Comment.Avatar
            src="https://react.semantic-ui.com/images/avatar/small/matt.jpg"
            style={{ width: "65px", height: "67px" }}
          />
          <Comment.Content>
            <Comment.Author as="a">{author.name}</Comment.Author>
            <Comment.Metadata>
              <div>{moment(itemRv.createdAt).format("DD/MM/YYYY")}</div>
              <div>
                <Rating
                  starts={itemRv.rating}
                  color={"gold"}
                  change={false}
                  size={"1.5rem"}
                  top={"6px"}
                />
              </div>
            </Comment.Metadata>
            <Comment.Text>{itemRv.text}</Comment.Text>
          </Comment.Content>
        </Comment>
      );
    });

    return (
      <>
        <Container className="detailsCont">
          <NavTab display={"none"} />
          <PagePath pages={["Ghurfaty", "Véhicule", "Location", modele]} links={["/home","/cars","/cars/location","/cars/location"]}/>
          <Container className="d-flex justify-content-between pr-0">
            <div className="col-12 col-lg-6">
              <p id="typeService">Location</p>
              <div className="d-flex justify-content-between align-items-center">
                <p id="carName" className="al">
                  {title}
                </p>
                <p id="etat" className="a">
                  {Math.round(rating *2)}/10 ({reviews.length})
                </p>
              </div>
              <div className="carOffer d-flex justify-content-between">
                <div className="offerInfos">
                  <p className="locationInfos">
                    {commune} {region} .{pays}
                  </p>
                  <p className="locationInfos">Avec/Sans chauffeur</p>
                  <p className="locationInfos">35 ans</p>
                </div>
                <div className="offerPrice">
                  <p id="principalPrice" className="locationPrice">
                    {parjour.prix} {parjour.currancy}/Jour/{parjour.distMAx} Km
                  </p>
                  <p className="locationPrice">
                    {parsemaine.prix} {parsemaine.currancy}/Semaine/
                    {parsemaine.distMAx} Km
                  </p>
                  <p className="locationPrice">
                    {parmois.prix} {parmois.currancy}
                    {parmois.distMAx} Km
                  </p>
                </div>
              </div>
              <div className="carFeatures d-flex justify-content-between">
                <h3>
                  <span className="featuresQte">{nbrSiege - 1}+1</span>Sièges
                </h3>
                <h3>
                  <span className="featuresQte">{nbrPortes}</span>Portes
                </h3>
                {siegeBebe && (
                  <h3>
                    <span className="featuresQte">1</span>Siège Bébé
                  </h3>
                )}
              </div>
              <h3 className="descrip mt-3">Description</h3>
              <div className="description d-flex justify-content-between">
                <div className="firstDesc">
                  <p>
                    Marque: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {marque}
                    </b>
                  </p>
                  <p>
                    Energie: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {energie}
                    </b>
                  </p>
                  <p>
                    Transmission: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {transmission}
                    </b>
                  </p>
                  <p>
                    Kilométrage: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {kilometrage}
                    </b>
                  </p>
                </div>
                <div className="secondDesc">
                  <p>
                    Modèle: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {modele}
                    </b>
                  </p>
                  <p>
                    Moteur: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {moteur}
                    </b>
                  </p>
                  <p>
                    Année: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {annee}
                    </b>
                  </p>
                  <p>
                    Couleur: &nbsp;
                    <b style={{ color: "#212529", fontWeight: "800" }}>
                      {couleur}
                    </b>
                  </p>
                </div>
              </div>
              <h3 className="descrip mt-3">Équipements</h3>
              <div className="description d-flex justify-content-between">
                <div className="firstDesc">{option1}</div>
                <div className="secondDesc">{option2}</div>
              </div>
              <h3 className="descrip mt-3">Annonceur</h3>
              <div className="annonceur d-flex align-items-center">
                <a href={`/agent/profile/${creator._id}`} className="d-flex align-items-center">
                <img
                  id="annonceurImg"
                  src="/imgs/annonceur/imad.jpg"
                  alt="Annonceur"
                />
                <p id="annonceurName">{creator ? creator.name : "unknown"}</p>
                </a>
              </div>
              <h3 id="comm" className="descrip mt-3">
                Commentaires
              </h3>
              <div className="comm">
                <Comment.Group>
                  {reviewsBloc}

                  <Form reply onChange={this.onInputChange.bind(this)}>
                    <Form.TextArea
                      name="t xt-cmnt"
                      value={this.state.comment.text}
                    />
                    <Button
                      content="Add Reply"
                      onClick={this.submitComment.bind(this)}
                      labelPosition="left"
                      icon="edit"
                      primary
                    />
                  </Form>
                  <br />
                </Comment.Group>
              </div>
            </div>
            <div className="d-none col-5 d-lg-block mb-3 carPics mt-4">
              <Container style={{ left: "60px", top: "-50px" }}>
                <Gallery
                  nbrImages ={this.state.nbrImages}
                  img={`${HOST_NAME}/api/announces/${this.state.galleryId}/avatar/0`}
                  galleryId={this.state.galleryId}
                />
                <Col className="pl-0">
                  <FromToDate />
                </Col>
                <Row>
                  <Col className="pl-0">
                    <PriceDetails />
                  </Col>
                </Row>
                <Row className="pl-0">
                  <Col className="mt-3 pl-0">
                    <Button className="contact">
                      Contacter l'annonceur
                      <img
                        src="/imgs/resrervationIcons/annoncer-contacts.svg"
                        alt=""
                        className="profile-iconOr icon-cnt-fr"
                      />
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-1 pl-0">
                    <Button
                      className="reserver px-0 mx-0"
                      onClick={this.reserveForm}
                    >
                      Réserver maintenant
                      <img
                        src="/imgs/resrervationIcons/reserverMaintenant.svg"
                        alt=""
                        className="notifHear-iconOr icon-cnt-fr"
                      />
                    </Button>
                  </Col>
                </Row>
              </Container>
            </div>
          </Container>
        </Container>
        <Footer />
        <Modal
          isOpen={this.state.ratingModal}
          toggle={this.toogleRatingClose.bind(this)}
          className="rating-modal"
        >
          <ModalBody>
            <center>
              <h2>évaluer notre Hebergement</h2>
              <Rating change={true} starts={0} size={"2.5rem"} />
            </center>
            <br />
            <br />
            <Button
              className="quitter-btn"
              onClick={this.toogleRatingClose.bind(this)}
            >
              Quitter
            </Button>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    state,    
    rating : state.comment.rating,
    comment : state.comment
  };
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(CarDetails));
